<script setup>

import {ref} from "vue";

const competitionsCardEl = ref(null)
const activeTab = ref('competitions-list');

const setTab = (tab) => {
    console.log(tab)
    competitionsCardEl.value.selectTab(tab)
}

</script>

<template>
    <div class="pt-4">
        <h1 class="mb-5 text-center">Giveaways</h1>

        <card-tabbed
            ref="competitionsCardEl"
        >
            <card-tabbed-tab
                title="Giveaways"
                value="competitions-list"
                :active="activeTab=== 'competitions-list'"
            >
                <business-partner-competition-list
                    @navigate:tab="setTab"
                ></business-partner-competition-list>
            </card-tabbed-tab>

            <card-tabbed-tab
                title="Create Giveaway"
                value="create-competition"
                :active="activeTab=== 'create-competition'"
            >
                <business-partner-competition-create></business-partner-competition-create>
            </card-tabbed-tab>
        </card-tabbed>
    </div>
</template>

<style scoped>

</style>
